/* eslint-disable */
import { SIDEBAR_RIGHT_TOGGLE } from '../Sidebar.types';

/**
 * Toggle whether or not the sidebar is open
 * @returns {ActionCreator<FromPayload<null, {}, SIDEBAR_RIGHT_TOGGLE>>} The created `Action`
 */
const sidebarRightToggle = () => ({ fromPayload }) => {
  return fromPayload(null, {}, SIDEBAR_RIGHT_TOGGLE);
};

export default sidebarRightToggle;
